import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { IDriver } from "../../classes/Domain";
import { VALIDATION } from "../../AppConstants";

let rules = {
    relationshipLevel: [{ required_if: ['isExcluded', false] }],
    maritalStatus: [{ required_if: ['isExcluded', false] }],
    gender: [{ required_if: ['isExcluded', false] }],
    firstName: [{ required_if: ['isExcluded', false] }],
    lastName: [{ required_if: ['isExcluded', false] }],
    licenseNumber: [{ required_if: ['isExcluded', false] }],
    licenseState: [{ required_if: ['isExcluded', false] }, 'regex:/^[aA-zZ]{2,3}$/'],
    currentLicenseStatus: [{ required_if: ['isExcluded', false] }]
};

const customErrorMessages = {
    "regex.birthDate": VALIDATION.DATE_FORMAT,
};


export const allFieldsValidation = (data: IDriver) => {
    if (!data.isExcluded) {
        rules["birthDate"] = ['required', 'regex:/^\\d{2}\\/\\d{2}\\/\\d{4}$/', 'valid_date', 'valid_driver_age', 'valid_age'];
    }
    return allFieldsValidationCommon(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};